let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];

class EventsService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.SessionService = SessionService;
    }
  getEvents(){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getEvents,
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }



}

EventsService.$inject = inject;

export default EventsService;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/events/events.service.js
 **/